/** Editor i18n catalog: hub - the hub-design dashboard (2026-11-01). English is the key source; German uses "du" and real umlauts. */
import { defineMessages } from "../core.ts";

export const hub = defineMessages(
  {
    studio: "Aditor Studio ↗",
    accountMenu: "Account menu: Billing, Profile, Handbook, Sign out",
    trust: "Trust Battery {pct}%",

    cardLabel: "Card",
    noOffers: "No new offers",
    drawHint: "Draw a card",
    completedOne: "card completed this month",
    completedMany: "cards completed this month",
    giveMeACard: "Give me a Card",
    drawing: "Drawing…",
    drawLocked: "Unlocks at Novice",
    drawNone: "No urgent card is open for you right now - check back later.",
    drawOfferOpen: "Answer the offer waiting for you first.",
    drawRevision: "Hand in your open revision first.",
    offerRevisionOpen: "Hand in your open revision first, then you can take this card.",
    drawPaused: "Your offers are paused right now.",
    drawError: "Could not draw a card - try again.",

    offerOpenUntil: "New offer · open until {time}",
    offerRequested: "The client asked for you on this card.",
    offerMore: "{count} more waiting",
    accept: "✓ Accept",
    accepting: "Claiming…",
    decline: "Decline",
    declining: "Declining…",
    declineNote: "Decline passes it to the next editor straight away.",
    offerError: "That did not work - the offer may have moved on. Refresh and try again.",
    estimate: "est. ~{seconds}s",
    staticRate: "static",

    inProduction: "In production · due {when}",
    inProductionNoDeadline: "In production",
    submit: "Submit for review ↗",
    submitting: "Opening…",
    openBrief: "Open card",
    submitNote: "Submit opens this card's own upload. It counts as handed in once the file has landed.",
    giveBack: "Give it back",
    givingBack: "Giving back…",
    giveBackError: "Could not give the card back - try again.",
    cardOf: "{n} of {total}",
    railLabel: "Your cards",
    pullUrgent: "Take an urgent card",
    railDueIn: "{title}, due in {hours}h",
    railOverdue: "{title}, overdue",
    railGrace: "{title}, upload grace, {minutes} min left",
    inProductionGrace: "In production · upload grace, {minutes} min left",

    revision: "Revision · {hours}h left",
    revisionOverdue: "Revision · overdue",
    handinRevision: "Handin revision ↗",
    handingIn: "Opening…",
    comments: "Comments ↗",
    revisionNote: "The next revision shows up once this one is handed in.",
    noHandinLink: "No hand-in link for this card yet - ask Ops.",

    earnings: "Earnings",
    earningsCount: "{count} cards",
    earningsCountOne: "1 card",
    earningsPeriod: "{period}, updated after each hand-in.",
    earningsAwaitingOne: "{period}. 1 handed-in card is waiting for its price. It counts from your hand-in as soon as the price is set.",
    earningsAwaitingMany: "{period}. {count} handed-in cards are waiting for their price. They count from your hand-in as soon as the price is set.",
    viewBilling: "View billing",

    availability: "Availability",
    workingHours: "working hours",
    from: "From",
    until: "Until",
    perWeek: "cards / week",
    goalAria: "Your card goal every week",
    goalHint: "Your own target. It does not limit your offers.",
    timeZone: "Time zone",
    timeZoneError: "Pick a time zone from the list, e.g. Europe/Berlin.",
    offersVia: "Offers via",
    telegramHint: "Telegram is not connected yet - until it is, offers reach you on Slack. Connect it in the setup list.",
    save: "Save changes",
    saving: "Saving…",
    saved: "Saved",
    saveError: "Could not save your availability - try again.",
    loading: "Loading…",

    mentorship: "Mentorship & calls",
    calendar: "Calendar ↗",
    join: "Join",
    addToCalendar: "Add",
    callsEmptyTitle: "Connect your calendar",
    callsEmptyMeta: "Trainings and mentor calls",
    callsEmptyConnect: "Connect",
    callsNoneTitle: "No calls coming up",
    callsNoneMeta: "New trainings land in your calendar automatically",
    pageBack: "Back to dashboard",

    driveRoundsTitle: "Handed in through Drive",
    stage: "Stage",
    level: "LV {n}",
    unlocksAt: "When you reach {stage}",
    rankUpKicker: "New stage",
    rankUpTitle: "You reached {stage}",
    rankUpClose: "Nice",
    yourPerks: "Your perks",
    reqAdlingo: "AdLingo lessons",
    reqCleanCards: "Cards on time, revisions in time",
    reqCleanRule: "Counts when you hand in on time and resolve every revision within {hours}h. A late card just doesn't count, it never holds you back.",
    reqNotCounted: "{n} didn't count.",
    reqPending: "{n} wait on an open revision.",
    orCategory: "or win 1 monthly category",
    levelUpHow: "How to level up?",
    topStage: "Top stage reached. Your perks are on for good.",
    perkPayNext: "{stage} pay: base +{pct}%",
    perkPayNextTip: "Not your pay today. Once you are {stage}, every card you accept pays {pct}% more than base pay.",
    perkPayYours: "Your pay: base +{pct}%",
    perkPayTip: "Every card you accept pays {pct}% more than base pay.",
    payToday: "Your pay today: base +{pct}%",
    payTodayBase: "Your pay today: base pay",
    perkCategories: "Categories",
    perkCategoriesTip: "Compete in the monthly categories, the leaderboard where the best editors of the month win.",
    perkMentor: "Mentor newbies",
    perkMentorTip: "Mentor new editors and earn a bonus on their full-video deliveries.",
    perkFallback: "Urgent cards",
    perkFallbackTip: "Take urgent cards yourself: any card that has waited 12 hours or more.",
    perkTrust: "Trust Battery {n}",
    perkTrustTip: "Your Trust Battery starts at {n}%, which moves you up in the dispatch order.",

    adlingoOpen: "Open training",
    adlingoLessons: "{count}/{total} lessons",

    location: "Location",
    locationHint: "Your city and country, for scheduling.",
    city: "City",
    country: "Country",
  },
  {
    studio: "Aditor Studio ↗",
    accountMenu: "Kontomenü: Abrechnung, Profil, Handbuch, Abmelden",
    trust: "Trust-Batterie {pct} %",

    cardLabel: "Card",
    noOffers: "Keine neuen Angebote",
    drawHint: "Zieh eine Card",
    completedOne: "Card diesen Monat abgeschlossen",
    completedMany: "Cards diesen Monat abgeschlossen",
    giveMeACard: "Gib mir eine Card",
    drawing: "Wird gezogen…",
    drawLocked: "Ab Novice verfügbar",
    drawNone: "Gerade ist keine dringende Card für dich offen - schau später nochmal.",
    drawOfferOpen: "Beantworte zuerst das Angebot, das auf dich wartet.",
    drawRevision: "Reich zuerst deine offene Revision ein.",
    offerRevisionOpen: "Reich zuerst deine offene Revision ein, dann kannst du diese Card nehmen.",
    drawPaused: "Deine Angebote sind gerade pausiert.",
    drawError: "Es konnte keine Card gezogen werden - versuch es nochmal.",

    offerOpenUntil: "Neues Angebot · offen bis {time}",
    offerRequested: "Der Kunde hat dich für diese Card angefragt.",
    offerMore: "{count} weitere warten",
    accept: "✓ Annehmen",
    accepting: "Wird übernommen…",
    decline: "Ablehnen",
    declining: "Wird abgelehnt…",
    declineNote: "Mit dem Ablehnen geht die Card sofort an den nächsten Editor.",
    offerError: "Das hat nicht geklappt - das Angebot ist vielleicht schon weiter. Lade neu und versuch es nochmal.",
    estimate: "ca. {seconds} s",
    staticRate: "statisch",

    inProduction: "In Arbeit · fällig {when}",
    inProductionNoDeadline: "In Arbeit",
    submit: "Zur Prüfung einreichen ↗",
    submitting: "Wird geöffnet…",
    openBrief: "Karte öffnen",
    submitNote: "Einreichen öffnet den Upload genau dieser Card. Abgegeben ist sie erst, wenn die Datei angekommen ist.",
    giveBack: "Card zurückgeben",
    givingBack: "Wird zurückgegeben…",
    giveBackError: "Die Card konnte nicht zurückgegeben werden - versuch es nochmal.",
    cardOf: "{n} von {total}",
    railLabel: "Deine Cards",
    pullUrgent: "Dringende Card nehmen",
    railDueIn: "{title}, fällig in {hours} Std.",
    railOverdue: "{title}, überfällig",
    railGrace: "{title}, Upload-Kulanz, noch {minutes} Min.",
    inProductionGrace: "In Arbeit · Upload-Kulanz, noch {minutes} Min.",

    revision: "Revision · noch {hours} h",
    revisionOverdue: "Revision · überfällig",
    handinRevision: "Revision einreichen ↗",
    handingIn: "Wird geöffnet…",
    comments: "Kommentare ↗",
    revisionNote: "Die nächste Revision erscheint, sobald diese eingereicht ist.",
    noHandinLink: "Für diese Card gibt es noch keinen Einreich-Link - frag Ops.",

    earnings: "Verdienst",
    earningsCount: "{count} Cards",
    earningsCountOne: "1 Card",
    earningsPeriod: "{period}, aktualisiert nach jeder Abgabe.",
    earningsAwaitingOne: "{period}. 1 abgegebene Card wartet auf ihren Preis und zählt ab deiner Abgabe, sobald er feststeht.",
    earningsAwaitingMany: "{period}. {count} abgegebene Cards warten auf ihren Preis und zählen ab deiner Abgabe, sobald er feststeht.",
    viewBilling: "Abrechnung ansehen",

    availability: "Verfügbarkeit",
    workingHours: "Arbeitszeit",
    from: "Von",
    until: "Bis",
    perWeek: "Cards / Woche",
    goalAria: "Dein Card-Ziel pro Woche",
    goalHint: "Dein eigenes Ziel. Es begrenzt deine Angebote nicht.",
    timeZone: "Zeitzone",
    timeZoneError: "Wähl eine Zeitzone aus der Liste, z. B. Europe/Berlin.",
    offersVia: "Angebote über",
    telegramHint: "Telegram ist noch nicht verbunden - bis dahin erreichen dich Angebote über Slack. Du verbindest es in der Setup-Liste.",
    save: "Änderungen speichern",
    saving: "Wird gespeichert…",
    saved: "Gespeichert",
    saveError: "Deine Verfügbarkeit konnte nicht gespeichert werden - versuch es nochmal.",
    loading: "Wird geladen…",

    mentorship: "Mentoring & Calls",
    calendar: "Kalender ↗",
    join: "Beitreten",
    addToCalendar: "Hinzufügen",
    callsEmptyTitle: "Verbinde deinen Kalender",
    callsEmptyMeta: "Trainings und Mentoring-Calls",
    callsEmptyConnect: "Verbinden",
    callsNoneTitle: "Gerade keine Calls geplant",
    callsNoneMeta: "Neue Trainings landen automatisch in deinem Kalender",
    pageBack: "Zurück zum Dashboard",

    driveRoundsTitle: "Über Drive eingereicht",
    stage: "Stage",
    level: "LV {n}",
    unlocksAt: "Sobald du {stage} bist",
    rankUpKicker: "Neue Stage",
    rankUpTitle: "Du hast {stage} erreicht",
    rankUpClose: "Stark",
    yourPerks: "Deine Vorteile",
    reqAdlingo: "AdLingo-Lektionen",
    reqCleanCards: "Cards pünktlich, Revisionen rechtzeitig",
    reqCleanRule: "Zählt, wenn du pünktlich abgibst und jede Revision innerhalb von {hours} h erledigst. Eine verspätete Card zählt einfach nicht, sie hält dich nie auf.",
    reqNotCounted: "{n} haben nicht gezählt.",
    reqPending: "{n} warten auf eine offene Revision.",
    orCategory: "oder gewinne 1 Monatskategorie",
    levelUpHow: "Wie steige ich auf?",
    topStage: "Höchste Stage erreicht. Deine Vorteile bleiben dir.",
    perkPayNext: "{stage}-Vergütung: Basis +{pct} %",
    perkPayNextTip: "Nicht deine Vergütung heute. Sobald du {stage} bist, bringt jede Card, die du annimmst, {pct} % mehr als die Grundvergütung.",
    perkPayYours: "Deine Vergütung: Basis +{pct} %",
    perkPayTip: "Jede Card, die du annimmst, bringt {pct} % mehr als die Grundvergütung.",
    payToday: "Deine Vergütung heute: Basis +{pct} %",
    payTodayBase: "Deine Vergütung heute: Grundvergütung",
    perkCategories: "Kategorien",
    perkCategoriesTip: "Tritt in den Monatskategorien an, der Bestenliste, in der die besten Editoren des Monats gewinnen.",
    perkMentor: "Newbies betreuen",
    perkMentorTip: "Betreue neue Editoren und verdien einen Bonus auf ihre Full-Video-Lieferungen.",
    perkFallback: "Dringende Cards",
    perkFallbackTip: "Nimm dir dringende Cards selbst: jede Card, die seit 12 Stunden oder länger wartet.",
    perkTrust: "Trust-Batterie {n}",
    perkTrustTip: "Deine Trust-Batterie startet bei {n} %, das bringt dich in der Dispatch-Reihenfolge nach vorn.",

    adlingoOpen: "Training öffnen",
    adlingoLessons: "{count}/{total} Lektionen",

    location: "Standort",
    locationHint: "Deine Stadt und dein Land, für die Planung.",
    city: "Stadt",
    country: "Land",
  },
);
